export default "/images/vendor/flag-icon-css/flags/4x3/lt.svg?93a07daff68dea7336fd2f400ed2fdd1";